import React from "react";
import { FaPrint, FaTimes } from "react-icons/fa";

export const ShippingLabelPrintModal = ({ isOpen, orderInfo, onClose }) => {
  if (!isOpen || !orderInfo) return null;

  const recipientName = `${orderInfo.firstName || ""} ${orderInfo.lastName || ""}`.trim() || "-";
  const recipientPhone = orderInfo.phone || "-";
  const fullAddress = `${orderInfo.address?.addr || ""} ${orderInfo.address?.province || ""} ${orderInfo.address?.zipcode || ""}`.trim() || "-";
  const shortId = orderInfo.shortId || orderInfo.id?.slice(-5)?.toUpperCase() || "";

  const handlePrint = () => {
    window.print();
  };

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-slate-900/60 backdrop-blur-xs p-4 animate-in fade-in duration-200"
      onClick={onClose}
    >
      <div
        className="relative bg-white border border-slate-300 rounded-md max-w-xl w-full flex flex-col shadow-2xl overflow-hidden"
        onClick={(e) => e.stopPropagation()}
      >
        {/* Modal Header */}
        <div className="flex items-center justify-between px-4 py-3 border-b border-slate-200 bg-slate-50 print:hidden">
          <h4 className="font-bold text-sm text-slate-800 flex items-center gap-1.5">
            <FaPrint className="text-blue-600" />
            <span>ใบปะหน้าพัสดุ (Shipping Label) #{shortId}</span>
          </h4>
          <div className="flex items-center gap-2">
            <button
              type="button"
              onClick={handlePrint}
              className="bg-blue-600 hover:bg-blue-700 text-white font-bold py-1.5 px-3 rounded-md text-xs flex items-center gap-1.5 transition-colors shadow-xs cursor-pointer"
            >
              <FaPrint />
              <span>พิมพ์ใบปะหน้า</span>
            </button>
            <button
              type="button"
              onClick={onClose}
              className="text-slate-400 hover:text-slate-600 p-1.5 rounded-md text-sm transition-colors cursor-pointer"
            >
              <FaTimes />
            </button>
          </div>
        </div>

        {/* Printable Label Area */}
        <div className="p-6 bg-white flex flex-col gap-4 text-slate-900 font-sans border-2 border-dashed border-slate-300 m-4 rounded-md">
          {/* Sender Box */}
          <div className="border-b border-slate-300 pb-3">
            <p className="text-xs font-bold text-slate-500 uppercase tracking-wider">
              ผู้ส่ง (Sender):
            </p>
            <p className="text-sm font-bold text-slate-900 mt-0.5">
              บริษัท วันดี พลัส จำกัด (หงษ์ทอง ออนไลน์)
            </p>
            <p className="text-xs text-slate-600 mt-0.5">
              เลขที่ 123 อาคารสำนักงานใหญ่ ถ.สุขุมวิท แขวงคลองเตย เขตคลองเตย กรุงเทพฯ 10110
            </p>
            <p className="text-xs text-slate-700 font-semibold mt-0.5">
              โทร: 02-123-4567
            </p>
          </div>

          {/* Recipient Box */}
          <div className="flex flex-col gap-1 py-1">
            <p className="text-xs font-bold text-blue-700 uppercase tracking-wider">
              ผู้รับ (Recipient):
            </p>
            <p className="text-base font-bold text-slate-900">
              คุณ {recipientName}
            </p>
            <p className="text-xs font-bold text-slate-800">
              เบอร์โทรศัพท์: {recipientPhone}
            </p>
            <p className="text-sm font-medium text-slate-800 mt-1 leading-relaxed bg-slate-50 p-2.5 rounded-md border border-slate-200">
              {fullAddress}
            </p>
          </div>

          {/* Footer with Order Info & Barcode Placeholder */}
          <div className="flex items-center justify-between border-t border-slate-300 pt-3 text-xs">
            <div>
              <p className="font-bold text-slate-700">Order #{shortId}</p>
              <p className="text-[11px] text-slate-500">จำนวนสลาก: {orderInfo.size || 0} ใบ</p>
              {orderInfo.shippingTrack && (
                <p className="font-bold text-slate-800 mt-0.5">Tracking: {orderInfo.shippingTrack}</p>
              )}
            </div>
            <div className="text-right">
              <div className="font-mono font-bold text-sm tracking-widest bg-slate-100 px-3 py-1.5 rounded-md border border-slate-300 inline-block">
                *{shortId}*
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
